import { render, staticRenderFns } from "./StatsByCorrectCount.vue?vue&type=template&id=49aa2443&scoped=true&"
import script from "./StatsByCorrectCount.vue?vue&type=script&lang=ts&"
export * from "./StatsByCorrectCount.vue?vue&type=script&lang=ts&"
import style0 from "./StatsByCorrectCount.vue?vue&type=style&index=0&id=49aa2443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa2443",
  null
  
)

export default component.exports